module.exports = __webpack_public_path__ + "sheep2.d2c22867.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/content/sheep2.svg
 ** module id = 112
 ** module chunks = 0
 **/